import { render, staticRenderFns } from "./MagazineIssue.vue?vue&type=template&id=2c3bf579&scoped=true"
import script from "./MagazineIssue.vue?vue&type=script&lang=js"
export * from "./MagazineIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3bf579",
  null
  
)

export default component.exports